import {AxiosError} from 'axios';
import {GET_DOWNLOAD_REQUEST_FILE_PRESIGNED_URL} from 'web-library/constants/apiUrls';
import {FilePresignedResponse} from 'web-library/models/UploadedFile';
import {GET_DOWNLOAD_REQUEST_FILE_PRESIGNED_KEY} from 'web-library/constants/queryKeys';
import {useCustomQuery} from '../utils/useCustomQuery';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: FilePresignedResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  fileUuid: string;
  enabled: boolean;
}

export const useGetDownloadRequestFilePresignedUrl = ({
                                                        onSuccess,
                                                        onError,
                                                        fileUuid,
                                                        enabled,
                                                      }: Input) => {
  const getAdminDownloadApplicationFilePresigned = async () => {
    const res = await axiosClient.get<FilePresignedResponse>(
        GET_DOWNLOAD_REQUEST_FILE_PRESIGNED_URL(fileUuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_DOWNLOAD_REQUEST_FILE_PRESIGNED_KEY.concat(fileUuid),
      getAdminDownloadApplicationFilePresigned,
      {
        onSuccess,
        onError,
        enabled,
      }
  );
};
